// core/timeFormat.js — media times as "mm:ss" (plan bugfix_2026-10-06_permission-tagging, phase video-steuerung).
// Minutes are not capped at 59: a 75-minute video shows "75:00". Two older copies of the formatting live in
// documents.js and TagBoxJQueryAdapter (formatTagTime) — switching them over is a polishing step.

// 83.7 → "01:23". Negative or not a number → "00:00".
export function formatMmSs(seconds) {
    const total = Number.isFinite(seconds) && seconds > 0 ? Math.floor(seconds) : 0;
    const mm = String(Math.floor(total / 60)).padStart(2, '0');
    const ss = String(total % 60).padStart(2, '0');
    return `${mm}:${ss}`;
}

// "1:23" → 83, "83" → 83, " 01:05 " → 65. Anything else ("", "1:2:3", "a:10", "1:75") → null.
export function parseMmSs(text) {
    const parts = String(text ?? '').trim().split(':');
    if (parts.length > 2 || parts.some((p) => !/^\d+$/.test(p))) { return null; }
    if (parts.length === 1) { return parseInt(parts[0], 10); }
    const [mm, ss] = parts.map((p) => parseInt(p, 10));
    return ss < 60 ? mm * 60 + ss : null;
}
